import _ from 'lodash';
import moment from 'moment';
import BaseModel from './BaseModel';
import OBJ_TYPES from './ObjectTypes';

export default class User extends BaseModel {
  constructor(user) {
    super(OBJ_TYPES.USER, user.user_id);

    this.username = user.username;
    this.firstName = user.first_name;
    this.lastName = user.last_name;
    this.email = user.email;
    this.avatarUrl = user.avatar_url || 'https://clip.ps/wp-content/uploads/2019/05/defaultAvatar.png';
    this.accessToken = user.token;
    this.streamToken = user.stream_token;
    this.tokenExpiration = moment().add(30, 'd');
    this.scopes = user.scopes;
    this.categories = user.categories || [];
    this.followers = user.followers;
    this.followerCount = user.followerCount;
    this.followingCount = user.followingCount;
    this.lastLogin = user.last_login || moment();
    this.archived = !!user.archived;
    this.emailConfirmed = !!user.emailConfirmed;
  }

  getId() {
    return this.id;
  }
  setId(id) {
    this.id = id;
  }

  getUsername() {
    return this.username;
  }
  setUsername(username) {
    this.username = username;
  }

  getFirstName() {
    return this.firstName;
  }
  setFirstName(firstName) {
    this.firstName = firstName;
  }

  getLastName() {
    return this.lastName;
  }
  setLastName(lastName) {
    this.lastName = lastName;
  }

  getEmail() {
    return this.email;
  }

  getAvatarUrl() {
    return this.avatarUrl;
  }

  getAccessToken() {
    return this.accessToken;
  }

  getStreamToken() {
    return this.streamToken;
  }

  getTokenExpiration() {
    return this.tokenExpiration;
  }

  getScopes() {
    return this.scopes;
  }

  getCategories() {
    return this.categories || [];
  }

  getFollowerCount() {
    return this.followerCount;
  }

  getFollowingCount() {
    return this.followingCount;
  }

  getFollowers() {
    return this.followers;
  }

  getLastLogin() {
    return this.lastLogin;
  }

  isArchived() {
    return this.archived;
  }

  isEmailConfirmed() {
    return this.emailConfirmed;
  }

  deSerialize(ob) {
    super.deSerialize(ob);
    this.username = ob.username;
    this.firstName = ob.firstName;
    this.lastName = ob.lastName;
    this.email = ob.email;
    this.avatarUrl = ob.avatarUrl;
    this.accessToken = ob.accessToken;
    this.streamToken = ob.streamToken;
    this.tokenExpiration = ob.tokenExpiration;
    this.scopes = ob.scopes;
    this.categories = ob.categories;
    this.followingCount = ob.followingCount;
    this.followerCount = ob.followerCount;
    this.followers = ob.followers;
    this.lastLogin = ob.lastLogin;
    this.archived = ob.archived;
    this.emailConfirmed = ob.emailConfirmed;
  }

  serialize() {
    return _.merge(super.serialize(), {
      username: this.username,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      avatarUrl: this.avatarUrl,
      accessToken: this.accessToken,
      streamToken: this.streamToken,
      tokenExpiration: this.tokenExpiration,
      scopes: this.scopes,
      categories: this.categories,
      followingCount: this.followingCount,
      followerCount: this.followerCount,
      followers: this.followers,
      lastLogin: this.lastLogin,
      archived: this.archived,
      emailConfirmed: this.emailConfirmed,
    });
  }
}
